
import { CONSTANT } from '@/constant/index'
import { setUploadFile } from '@/database/index'
import { faces } from '@/assets/script/utils'

class SendControl {

  constructor(chatControl) {
    this.chatControl = chatControl
    this.content = ''
    this.faces = this.getFace()
  }

  /**
   * 获取表情
   */
  getFace () {
    const _faces = []
    for (const key in faces) {
      _faces.push({
        key: key,
        url: faces[key]
      })
    }
    return _faces
  }

  /**
   * 添加表情
   * @param {string} face 表情字符 
   */
  addFace (face) {
    this.content = this.content + `face${face}`
  }

  /**
   * 清空输入框
   */
  clear () {
    this.content = ''
  }

  /**
   * 添加图片
   * @param {File} file 文件file
   */
  async addImage (file) {
    const { chatModel, connected } = this.chatControl
    const config = {
      type: connected ? 'SEND, IMAGE, ARTIFICIAL' : 'SEND, IMAGE',
      title: `img[${CONSTANT.IMAGE_TIP.LOADING}]`,
    }
    if (connected) config.unread = true
    const info = await chatModel.add(config)

    try {
      const reslut = await setUploadFile({ file })
      const imgStr = `img[${reslut.src}]`
      chatModel.setInfoTitle({
        id: info.id,
        title: imgStr
      })
      // sockect是否连接
      if (connected) {
        this.chatControl.socketControl.send(imgStr, info.id)
      } else {
        this.chatControl.addInfoByReceive({
          title: CONSTANT.ANSWER_NO_REPLY
        }, true)
      }

    } catch (error) {
      // 错误更换error图片
      chatModel.setInfoTitle({
        id: info.id,
        title: `img[${CONSTANT.IMAGE_TIP.ERROR}]`
      })
    }
  }

  /**
   * 输入中
   * @param {string} type 事件类型 
   */
  entering (type) {
    if (!this.chatControl.connected) return

    const { socketControl } = this.chatControl
    const status = type === 'focus' ? 1 : 2
    socketControl.entering(status)
  }

}

export default SendControl


// WEBPACK FOOTER //
// ./src/controller/modules/sendControl.js